function findOfferingByTitle(offerings, title) {
    return offerings.find((offering)=>new RegExp(title, 'i').test(Object.values(offering.title).join(','))
    );
}
function selectOffering(offerings, title) {
    return findOfferingByTitle(offerings, title) || offerings[0];
}

export { findOfferingByTitle, selectOffering };
//# sourceMappingURL=offerings.js.map
